import { useReactiveVar } from '@apollo/client';

import { AuthenticationState, Path, RedirectState, getPath } from '@neo.tax/shared';

/**
 * Guard hook for `/verify-email-sent` and `/verify-email`: if the user is
 * already signed in AND their Firebase token carries `email_verified: true`,
 * send them to `/login` — which is where `useAuthRedirect` takes over and
 * forwards them to their real dashboard (profile vs companies).
 *
 * Unauthenticated visitors and unverified-but-signed-in users stay on the
 * page (that's the intended audience of the verification pages).
 */
export const useRedirectIfEmailVerified = (): RedirectState => {
  const { authenticationServiceState } = useReactiveVar(AuthenticationState.authenticationStateVar);
  const authenticationUser = authenticationServiceState.authenticationUser;

  if (authenticationServiceState.loading) {
    return { isLoading: true };
  }

  if (authenticationUser?.emailVerified) {
    return { isLoading: false, redirectTo: getPath({ path: Path.LOGIN }) };
  }

  return { isLoading: false };
};
